import { compose, composeU } from '@bem-react/core';
import { withGapS, withGapM, withGapL, withGapXL, withPinCircle, withPinRound, ButtonGroup as ButtonGroupDesktop, } from '..';
export * from '..';
export var ButtonGroup = compose(composeU(withGapS, withGapM, withGapL, withGapXL), composeU(withPinCircle, withPinRound))(ButtonGroupDesktop);
